import { motion } from "framer-motion";

export default function Manifesto({ data }) {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-40 px-6 md:px-12 lg:px-16 overflow-hidden"
    >
      <div className="max-w-[1600px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9 }}
          className="mb-16 md:mb-24 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end"
        >
          <div className="lg:col-span-8">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-12 h-px bg-accent" />
              <span className="font-body text-[11px] uppercase tracking-[0.35em] text-accent">
                {data.eyebrow}
              </span>
            </div>
            <h2
              data-testid="about-title"
              className="font-heading uppercase text-white text-5xl md:text-7xl lg:text-[7.5rem] leading-[0.9]"
            >
              {data.title}
            </h2>
          </div>
          <div className="lg:col-span-4">
            <div className="font-body text-xs uppercase tracking-[0.3em] text-white/40">
              Manifesto
            </div>
            <div className="font-heading text-4xl md:text-5xl text-white/80 mt-2">
              04 capitoli
            </div>
          </div>
        </motion.div>

        <div className="space-y-1">
          {data.chapters.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`chapter-${c.n}`}
              className="group relative border-t border-white/10 py-10 md:py-14 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10"
            >
              <div className="lg:col-span-2">
                <span className="font-heading text-7xl md:text-8xl lg:text-9xl text-white/10 group-hover:text-accent/40 transition-colors duration-700 leading-none block">
                  {c.n}
                </span>
              </div>
              <div className="lg:col-span-4">
                <h3 className="font-heading text-3xl md:text-4xl uppercase text-white leading-tight">
                  {c.title}
                </h3>
              </div>
              <div className="lg:col-span-6">
                <p className="font-body text-base md:text-lg text-white/60 leading-relaxed max-w-xl">
                  {c.body}
                </p>
              </div>
              <div className="absolute bottom-0 left-0 h-px bg-accent w-0 group-hover:w-full transition-all duration-1000 ease-out" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
